import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/components/User";
import { HALLO_WEBSOCKET } from "@/common/http";
import { isString } from "@/common/utils";
import $store from '@/store';

@Component
export default class WebSocket extends Vue {
  updateOnlineUserList:boolean = false;
  waiting: boolean = false;
  TotalUsers: number = 0;
  OnlineUsers: {[key:string] : any}[] = [];
  //OnlineUserCounts = '0000'; // updated after login via WebSocket
  
  get User() : User {
    return $store.getters.User;
  }

  get OnlineUserCounts() : string {
    let n = Math.max((this.TotalUsers+'').length, 4);
    return ('0000' + this.TotalUsers).slice(-n);
  }
  
  setOnlineUserCounts(count:string) {
    //let n = Math.max((count).length, 4);
    //this.OnlineUserCounts = ('0000' + count).slice(-n);
  }
  
  open() {
    // in order to sync data of online users
    try {
      //the vue-native-websocket must be first injected in @/plubins/vuetify.js
      let $connect = this['$connect'];
      let $sockets = this.$options['sockets'];
      if ($connect && $sockets) {
        $sockets.onmessage = this.onMessage;
        $sockets.onclose = (event) => {
          this.connect();
        }
        this.connect();
      }
    } catch (error) {
      console.log(error);
    }
  }
  
  connect() {
    let url = HALLO_WEBSOCKET + this.User.HalloId + '/' + this.User.Token.hallo;
    this['$connect'](url, {
      //reconnection: true, // (Boolean) whether to reconnect automatically (false)
      //reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
      //reconnectionDelay: 2000, // (Number) how long to initially wait before attempting a new (1000)
      format: 'json'
    });
  }

  disconnect() {
    delete this.$options['sockets'].onmessage;
    this['$disconnect']();
  }

  send(data:{[key:string] : any} | string) {
    let $socket = this['$socket'];
    if ($socket) {
      if (isString(data)) {
        $socket.send(data);
      } else {
        this.waiting = true;
        $socket.sendObj(data);
      }
    } else {
      console.log('$socket is not defined');
    }
  }
  
  callBack() {} // to be override, such as from ./toc/online.users.vue

  private onMessage(event) {
    //console.log(event);
    let data = event.data;
    let dataType;
    if (data) {
      data = JSON.parse(data);
      dataType = data.type;
      data = data.payload.data;
      this.TotalUsers = data.total || this.TotalUsers;
      switch (dataType) {
      case 'reconnection':
        this.User.Token.hallo = data.token;
        break;
      case 'notification_welcome':
        if (this.updateOnlineUserList) {
          let exists = (this.OnlineUsers.length>=this.TotalUsers);
          if (!exists) {
            this.OnlineUsers.push({
              //id: data.id,
              name: data.name,
              surname: data.surname,
              email: data.email,
              org_abbr: data.org_abbr,
              org_name: data.org_name
            });
          }
        }
        break;
      case 'notification_closed':
        if (this.updateOnlineUserList) {
          this.OnlineUsers.forEach((u,idx) => {
            if (u.email==data.email) {
              this.OnlineUsers.splice(idx,1);
              return;
            }
          });
        }
        break;
      case 'notification_users':
        this.OnlineUsers = [];
        if (data.users) {
          data.users.forEach((user) => {
            this.OnlineUsers.push({
              id: user.id,
              name: user.name,
              surname: user.surname,
              email: user.email,
              group: user.group,
              mobile: user.mobile,
              org_abbr: user.org_abbr,
              org_name: user.org_name
            });
          });
        }
        this.waiting = false;
        break;
      }
    }
  }
}